import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import LoaderModal from "../../../../modal/LoaderModal";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import { Row, Col, Alert, Table } from "react-bootstrap";
import "./circlebar.css";
import "./reportsbmptn.css";
import { TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";

class RekomendasiSbmptn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            listRekom: [],
            listNonRekom: [],
            detail: [],
        };
    }

    async componentDidMount() {
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        const param = this.props.match.params;
        let qString = {
            idSekolah: this.props.account.idSekolah,
            idKelas: param.idKelas,
            idJadwal: param.idJadwal,
            kelompok: param.kelompok,
        };

        const response = await accountManagement
            .get(CONFIG.REPORT_REKOMENDASI_SBMPTN, {
                params: qString,
            })
            .catch(function (error) {
                console.log(error);
            });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    listRekom: response.data.data.listRekom,
                    listNonRekom: response.data.data.listNonRekom,
                    detail: response.data.data.detail,
                });
            }
            this.setState({ isFetching: false });
        }
        this.setState({ isFetching: false });
    };

    renderTableRekom() {
        let { listRekom } = this.state;
        if (!__.isEmpty(listRekom)) {
            require("./reportsbmptn.css")
            return (
                <div className="card-profile" style={{ padding: '0px', borderRadius: '4px' }}>
                    <div class="Table">
                        <div class="Heading">
                            <div class="Cell">
                                <p>No</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Nama Siswa</p>
                            </div>
                            <div class="Cell">
                                <p>Pilihan</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Pilihan PTN</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Pilihan Prodi</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Rata Nilai</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Nilai Rataan Minimum</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Analisa</p>
                            </div>
                        </div>
                        {listRekom.map((val, i) => (
                            <div class="Row">
                                <div class="Cell" style={{ textAlign: 'center' }}>
                                    <p>{i + 1}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.namaSiswa}</p>
                                </div>
                                <div class="Cell" style={{ textAlign: 'center' }}>
                                    <p>{val.pilihan}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.namaPtn}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.namaProdi}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.nr}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.nrm}</p>
                                </div>
                                <div class="Cell">
                                    <p>{val.keterangan}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            );
        } else {
            return (
                <Row>
                    <Col>
                        <b>Data tidak tersedia</b>
                    </Col>
                </Row>
            );
        }
    }

    renderTableNonRekom() {
        let { listNonRekom } = this.state;
        if (!__.isEmpty(listNonRekom)) {
            return (
                <div className="card-profile" style={{ padding: '0px', borderRadius: '4px' }}>
                    <div class="Table">
                        <div class="Heading">
                            <div class="Cell" style={{width: '4%'}}>
                                <p>No</p>
                            </div>
                            <div class="Cell" style={{ textAlign: 'left' }}>
                                <p>Nama Siswa</p>
                            </div>
                        </div>
                        {listNonRekom.map((val, i) => (
                            <div class="Row">
                                <div class="Cell">
                                    <p>{i + 1}</p>
                                </div>
                                <div class="Cell" style={{ textAlign: 'left' }}>
                                    <p>{val.namaSiswa}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
    }

    render() {
        const { detail, listNonRekom } = this.state;
        return (
            <div className="container-fluid" style={{ paddingBottom: "50px" }}>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="stat-wrapper">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>01</span>
                        </div>
                        <div className="pnl-date">
                            <span>https://eduprime.co.id</span>
                        </div>
                    </div>
                    <Row style={{ marginBottom: '40px' }}>
                        <Col>
                            <div className="text-header" style={{ padding: '0px' }}>
                                <div className="title-header2">REKAPITULASI USS SNBT</div>
                            </div>
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                            <div className="image-header">
                                <div className="logo-edu">
                                    <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} style={{ width: '200px' }} />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="pnl-profile">
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Nama Sekolah</span>
                                <p className="label-profile-value">{detail.sekolah}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/mdi_date.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Nama Jadwal</span>
                                <p className="label-profile-value" style={{ verticalAlign: "middle" }}>{detail.namaJadwal}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-jum-peserta.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Kelompok</span>
                                <p className="label-profile-value">{detail.kelompok}</p>
                            </div>
                        </div>
                    </div>
                    <Row>
                        <Col>
                            <b style={{ fontSize: '20px', fontWeight: 700 }}>
                                Data Rekomendasi Siswa
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>{this.renderTableRekom()}</Col>
                    </Row>
                    &nbsp;
                    {!__.isEmpty(listNonRekom) && (
                        <>
                            <Row>
                                <Col>
                                    <b style={{ fontSize: '20px', fontWeight: 700 }}>
                                        Data Siswa yang belum memilih PTN tujuan
                                    </b>
                                </Col>
                            </Row>
                            <Row>
                                <Col>{this.renderTableNonRekom()}</Col>
                            </Row>
                        </>
                    )}
                    <div id="btn_print">
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(RekomendasiSbmptn);
